// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"b2ec73ca","453":"de6b0aed"}[chunkId] + ".chunk.js";
};